import { render, staticRenderFns } from "./ProjectInvoicesView.vue?vue&type=template&id=29679c2b&scoped=true&"
import script from "./ProjectInvoicesView.vue?vue&type=script&lang=js&"
export * from "./ProjectInvoicesView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInvoicesView.vue?vue&type=style&index=0&id=29679c2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29679c2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VDataTable,VFlex,VLayout,VTextField})
